import { httpClient } from '@/lib/http-client'
import type { ProjectListParams, ProjectListResponse, ProjectEpisodeListResponse } from './project.type'
import type { Response } from './type'

// 获取项目列表
export const apiGetProjectList = (data: ProjectListParams) =>
  httpClient.post<Response<ProjectListResponse>>('/motioncomic/project_list', data)

// 项目剧集列表
export const apiGetProjectEpisodeList = (data: { project_id: number }) =>
  httpClient.post<Response<ProjectEpisodeListResponse>>('/motioncomic/project_episode_list', data)
